import React from 'react';

const Logo: React.FC<{ size?: number; showText?: boolean }> = ({ size = 32, showText = true }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 3px 12px rgba(255, 255, 255, 0.4)',
        border: '2px solid rgba(99, 102, 241, 0.3)',
        width: size,
        height: size,
        overflow: 'hidden'
      }}>
        <img 
          src="/logo-new.png" 
          alt="BringIt" 
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'cover',
            display: 'block',
            transform: 'scale(1.4)',
            borderRadius: '8px'
          }}
        />
      </div>
      {showText && (
        <span style={{ 
          fontSize: size * 0.55, 
          fontWeight: 'bold', 
          background: 'linear-gradient(135deg, #1e3a5f 0%, #2d5a87 50%, #3a7ca5 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontFamily: 'Arial, sans-serif',
          textShadow: 'none',
          filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2))'
        }}>
          BringIt
        </span>
      )}
    </div>
  );
};

export default Logo;
